import * as universal_hooks from '../../../src/hooks.ts';

export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25')
];

export const server_loads = [];

export const dictionary = {
		"/": [4],
		"/account": [5],
		"/account/callback": [6],
		"/account/login": [7],
		"/account/orders": [8],
		"/admin": [9,[2]],
		"/admin/login": [10,[2]],
		"/cart4": [12],
		"/cart": [11],
		"/cookie-policy": [13],
		"/filters": [14],
		"/find-us": [15],
		"/mats": [~16],
		"/mats/[slug]": [~17],
		"/privacy-policy": [18],
		"/qa": [19,[3]],
		"/refunds-returns": [20],
		"/shipping-delivery": [21],
		"/shoes2": [~24],
		"/shoes": [~22],
		"/shoes/[slug]": [23],
		"/showcase": [25]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: universal_hooks.reroute || (() => {}),
	transport: universal_hooks.transport || {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';